// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"dbc17450","150":"8fa6e00c","453":"62d50b11","727":"9a473ef3","945":"dd967bf4"}[chunkId] + ".chunk.js";
};